import MultiSelect from "@/components/Forms/MultiSelect.tsx";
import { statuteOptions } from "@/components/Forms/SubForms/AccidentInfo.tsx";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import type React from "react";

const AccidentSection = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
}));

const FieldsGrid = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: theme.spacing(3),
}));

export const yesNoBooleanOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
];

export const yesNoBooleanOptionsWithBlank = [{ value: "", label: "" }, ...yesNoBooleanOptions];

export const yesNoOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
];

export const yesNoOptionsWithNone = [{ value: "none", label: "None" }, ...yesNoOptions];

export const statuteOptionsFormatted = statuteOptions.map((statute) => ({
    value: statute,
    label: statute,
}));

// Teams are now fetched dynamically from the database - see DateRangeFields.tsx

export const umUimCaseAccepted = [
    { value: "Pending", label: "Pending" },
    { value: "No", label: "No" },
    { value: "Yes", label: "Yes" },
];

const AccidentFields: React.FC = () => {
    return (
        <AccidentSection>
            <SectionTitle variant="h6">Accident Information</SectionTitle>
            <FieldsGrid>
                <MultiSelect
                    name="accidentReportDone"
                    label="Accident Report Done"
                    options={yesNoOptions}
                />

                <MultiSelect name="pdSettled" label="PD Settled" options={yesNoOptions} />

                <MultiSelect
                    name="primaryStatute"
                    label="Primary Statute"
                    options={statuteOptionsFormatted}
                />
            </FieldsGrid>
        </AccidentSection>
    );
};

export default AccidentFields;
